export const getHeaderHeight = () => {
	let headerHeight = document?.querySelector('.header').offsetHeight;
	// let additionalHeight = document.querySelector('.info-note') ? document.querySelector('.info-note').offsetHeight : 0;
	// // let finalHeight = Number(headerHeight) + Number(additionalHeight);
	// let finalHeight = headerHeight + additionalHeight;

	// // console.log(headerHeight);
	// // console.log(additionalHeight);
	// // console.log(finalHeight);

	document.querySelector(':root').style.setProperty('--header-height', `${headerHeight}px`);
};
window.addEventListener('load', function () {
	setTimeout(function () {
		getHeaderHeight();
	}, 0);
});
